import { apiQuery } from '..';

export const UsersQuery = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getOrgRoles: builder.query({
        providesTags: ['GetOrgRoles'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/org_roles`,
          };
        },
      }),

      getOrgRoleById: builder.query({
        providesTags: ['GetOrgRoleById'],
        transformResponse: (response) => response?.data,
        query: ({ isNew, roleId }) => {
          let url = `/org_roles`;
          if (isNew) {
            url += '/new';
          }
          if (roleId) {
            url += `/${roleId}/edit`;
          }
          return {
            method: 'get',
            url: url,
          };
        },
      }),

      viewOrgRoleById: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ isNew, roleId }) => {
          return {
            method: 'get',
            url: `/org_roles/${roleId}`,
          };
        },
      }),

      createRole: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            url: `/org_roles/`,
            method: 'post',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.org_role?.id) {
            return [{ type: 'GetOrgRoles' }];
          }
          return [];
        },
      }),

      updateRole: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ roleId, payload }) => {
          return {
            url: `/org_roles/${roleId}`,
            method: 'patch',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (!result?.error) {
            return [{ type: 'GetOrgRoles' }, { type: 'GetOrgRoleById' }];
          }
          return [];
        },
      }),

      deleteRole: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ roleId, reassign_to }) => {
          let url = `/org_roles/${roleId}`;
          if (reassign_to) {
            url += `?reassign_to=${reassign_to}`;
          }
          return {
            url,
            method: 'delete',
          };
        },
        invalidatesTags: (result) => {
          if (!result?.error) {
            return [{ type: 'GetOrgRoles' }];
          }
          return [];
        },
      }),

      cloneRole: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ roleId, payload }) => {
          return {
            url: `/org_roles/${roleId}/clone`,
            method: 'post',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result?.org_role?.id) {
            return [{ type: 'GetOrgRoles' }];
          }
          return [];
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetOrgRolesQuery,
  useCloneRoleMutation,
  useDeleteRoleMutation,
  useGetOrgRoleByIdQuery,
  useLazyGetOrgRoleByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useLazyViewOrgRoleByIdQuery,
} = UsersQuery;
